import { useState } from "react";
import { CalcCard, NumField, ResultRow, PrimaryButton, Section, SaveButton } from "@/components/CalcUI";
import { runCalc } from "@/lib/api";
import { toast } from "sonner";

export default function FreePoint() {
  const [inp, setInp] = useState({ stretch: "10", pull_diff: "20000", pipe_wt: "19.5" });
  const [out, setOut] = useState(null);

  const run = async () => {
    try {
      const r = await runCalc("free_point", { stretch: parseFloat(inp.stretch), pull_diff: parseFloat(inp.pull_diff), pipe_wt: parseFloat(inp.pipe_wt) });
      setOut(r);
    } catch (e) {
      toast.error("Invalid inputs");
    }
  };

  return (
    <div data-testid="free-point-page">
      <Section
        title="Free Point"
        subtitle="Estimate the depth of stuck point using differential-pull stretch. Apply two pulls above overpull, measure stretch delta, and compute free pipe length."
      >
        <CalcCard testid="fp-card" title="Free Point (Stretch Method)" formula="L_free = ΔL·735,294·W_ppf / ΔPull">
          <div className="grid grid-cols-3 gap-3">
            <NumField testid="fp-stretch" label="Stretch" unit="in" value={inp.stretch} onChange={(v) => setInp({ ...inp, stretch: v })} hint="Between two pulls" />
            <NumField testid="fp-pull" label="Pull diff" unit="lbf" value={inp.pull_diff} onChange={(v) => setInp({ ...inp, pull_diff: v })} hint="High − Low pull" />
            <NumField testid="fp-wt" label="Pipe weight" unit="lb/ft" value={inp.pipe_wt} onChange={(v) => setInp({ ...inp, pipe_wt: v })} hint="Nominal DP wt" />
          </div>
          <div className="mt-4 flex justify-between">
            <PrimaryButton testid="fp-run" onClick={run}>Calculate</PrimaryButton>
            <SaveButton getPayload={() => out && { category: "Free Point", calculator: "free_point", inputs: inp, outputs: out, units: "field", default_name: "Free Point" }} />
          </div>
          {out && (
            <div className="mt-4 border-t border-[#334155] pt-3">
              <ResultRow label="Free pipe length" value={out.free_point_ft} unit="ft" emphasis />
              <div className="text-[10px] mono text-[#94a3b8] mt-2 leading-relaxed">
                Method: differential pull above weight above overpull. Below this depth the string is stuck. Confirm with a free-point log before backing off.
              </div>
            </div>
          )}
        </CalcCard>
      </Section>
    </div>
  );
}
